import { render, staticRenderFns } from "./BasicInfoSection.vue?vue&type=template&id=6afac01a&scoped=true&"
import script from "./BasicInfoSection.vue?vue&type=script&lang=js&"
export * from "./BasicInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoSection.vue?vue&type=style&index=0&id=6afac01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afac01a",
  null
  
)

export default component.exports